import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import NoBreachesFound from "./NoBreachesFound";
import SearchResultTable from "./SearchResultTable";
import { getSearchBreachByName } from "../../../store/service";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { useForm } from "react-hook-form";
import BreachPagination from "./BreachPagination";
import MagnifyIcon from "../../../Assets/images/breach_search_magnify.svg";
import BreachesTab from "../BreachesTab";
import BreachHeaderText from "../BreachHeaderText";
import { breachServiceActive } from "../../../util/CommonBreach";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import LogoContainer from "../../common/LogoContainer";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

interface ISearchResponse {
    no_Of_Records: number;
    body: any[];
    message: string;
}

function SearchBreachesResults(props: any) {
    const history = useHistory();
    const dispatch = useDispatch();
    const [search, setSearch] = useState(((props.location && props.location.state.search) as any) || ({} as any));
    const [page, setPage] = useState(1);
    const [breachResults, setBreachResults] = useState<ISearchResponse>({
        no_Of_Records: 0,
        body: [],
        message: "",
    });
    const breachService = useSelector((state: ApplicationState) => (state.breachServiceState ? state.breachServiceState.breachService : null));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [isLoading, setIsLoading] = useState(false);

    const { register, handleSubmit, errors, clearErrors } = useForm({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
    });

    const searchKey = ((props.location && props.location.state.search) as any) || ({} as any);

    const onSubmit = (values: any) => {
        if (values.search) {
            setPage(1);
            setSearch(values.search);
            getSearchResults(values.search);
            history.push({
                state: { search: values.search },
            });
        }
    };

    const getSearchResults = (search: string) => {
        setIsLoading(true);
        getSearchBreachByName({ name: search }).then((res) => {
            setIsLoading(false);
            setBreachResults(res);
        });
    };

    useEffect(() => {
        if (searchKey) {
            getSearchResults(searchKey);
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const goBackToSearch = () => {
        history.push({
            pathname: `/breaches/search-breaches`,
        });
    };

    return (
        <Fragment>
            <div className="row">
                {!breachServiceActive(breachService) ? (
                    <div className="col-xs-12">
                        <h1 className="title-page" id="breach-search-results-page" tabIndex={-1} style={{ color: "#00313c" }}>
                            Breach Search
                        </h1>
                        <LogoContainer internalPage={true} />
                    </div>
                ) : (
                    <BreachHeaderText />
                )}
            </div>
            <BreachesTab selectedTab="4" />
            <div className="row middle-xs">
                <div className="result-back-arrow-box">
                    <span
                        className="btn-icon cursor-pointer"
                        style={{ width: "1.5rem" }}
                        onClick={() => {
                            goBackToSearch();
                        }}
                    >
                        <em className="las la-angle-left  breach-back-arrow-icon"></em>
                    </span>
                </div>
                <div className="col-xs">
                    <h1 className="title-page" id="search-results-title" tabIndex={-1}>
                        Search Results
                    </h1>
                </div>
            </div>

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <label htmlFor="search-breach" className="hide-label">Enter the name of the breached organization...</label>
                            <div className="form-input input-card">
                                <input
                                    type="text"
                                    className="inputbox input-breach-search"
                                    name="search"
                                    id="search-breach"
                                    placeholder="Enter the name of the breached organization..."
                                    onChange={(e) => {
                                        if (e.target.value.length >= 3) {
                                            clearErrors("search");
                                        }
                                    }}
                                    ref={register({ required: true, minLength: 3 })}
                                />
                                <button
                                    type="submit"
                                    id="btn-search-breach"
                                    className="btn-default btn-search-bg-color padding-right-s search-btn-search-breach display-flex-justify-center-align-center btn-primary"
                                    onClick={() => window.addToDataLayer({ event: "breachIQBtnSearch" })}
                                >
                                    <img src={MagnifyIcon} alt="Magnifying Glass" />
                                    <span className="btn-text btn-search-text padding-left-xs">Search</span>
                                </button>
                            </div>
                            {!!errors["search"] && errors["search"].type === "minLength" && (
                                <div className="error-breach-search">
                                    <span className="error-icon">
                                        <em className="las la-exclamation-triangle font-error"></em>
                                    </span>
                                    <span>Please enter at least three characters in search bar.</span>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-12">
                    <div className={isLoading ? "box loading" : "box"}>
                        <div className="box-header padding-left-5rem">
                            <div className="box-title-container">
                                {!isLoading ? (
                                    <div className="box-title-icon" aria-hidden="true">
                                        <RenderIcons iconName="breach-search" />
                                    </div>
                                ) : null}
                                {!isLoading ? (
                                    <div className="box-title-text">
                                        <h2 className="box-title">
                                            <span className="result-match">{breachResults && breachResults.no_Of_Records} Results</span> for breaches containing{" "}
                                            <span className="breach-text-search">{`"${search ? search : searchKey}"`}</span>
                                        </h2>
                                    </div>
                                ) : null}
                            </div>
                            {!isLoading && breachResults && breachResults.no_Of_Records ? (
                                <div className="box-content">
                                    <SearchResultTable breachResults={breachResults} page={page} searchKey={search} />
                                    {breachResults.no_Of_Records > 25 ? (
                                        <div className="breach-paging-container">
                                            <BreachPagination
                                                currentPageNo={page}
                                                numberOfRecord={breachResults.no_Of_Records}
                                                onChange={(val: number) => {
                                                    setPage(val);
                                                }}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}
                        </div>
                        {!isLoading && breachResults && breachResults.no_Of_Records === 0 ? (
                            <div className="box-content">
                                <NoBreachesFound />
                                <div></div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default SearchBreachesResults;
